import {createContext} from 'react';
import {IUser} from 'models/auth';
import {IProject} from "../models/project";

export const defaultUser: IUser = {
    access_token: '',
    first_name: '',
    last_name: '',
    id: '',
    username: '',
    role: '',
    created_at: Date.now().toString(),
    email: '',
};

export const UserContext = createContext<{
    user: IUser;
    setUser: (user: IUser) => void;
}>({
    user: defaultUser,
    setUser: () => {
    },
});

export const defaultProject: IProject = {
    id: '',
    topology: '',
    name: '',
    created_at: '',
    owner: '',
    params: {},
    results: {}
};

export const ProjectContext = createContext<{
    selectedProject: IProject;
    setSelectedProject: (project: IProject) => void;
}>({
    selectedProject: defaultProject,
    setSelectedProject: () => {
    },
});


export const DraftProjectContext = createContext<{
    draftProject: IProject;
    setDraftProject: (project: IProject) => void;
}>({
    draftProject: defaultProject,
    setDraftProject: () => {
    },
});